module.exports = __webpack_public_path__ + "img/back_blue_02.c99f93c2.jpg";